import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { setAlert } from '../../../slices/alertSlice';
import {
  // Button,
  TextField,
  FormControl,
  InputAdornment,
  makeStyles,
} from '@material-ui/core';
import Button from 'components/MaterialKit/CustomButtons/Button.js';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import LockIcon from '@material-ui/icons/Lock';
import { CheckFormikValues } from '../../../components/Formik/CheckFormikValues';
import CardBody from 'components/MaterialKit/Card/CardBody.js';
import CardHeader from 'components/MaterialKit/Card/CardHeader.js';
import styles from 'assets/jss/material-kit-react/views/loginPage.js';
import CardFooter from 'components/MaterialKit/Card/CardFooter';
const useStyles = makeStyles(styles);

const ResetPasswordForm = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const check = false;
  const {
    values,
    errors,
    touched,
    handleSubmit,
    handleBlur,
    handleChange,
  } = props;
  const [view, setView] = useState(false);

  return (
    <form onSubmit={handleSubmit} className={classes.form}>
      <CardHeader color='black' className={classes.cardHeader}>
        <h3>Reset Password</h3>
      </CardHeader>

      <CardBody>
        <FormControl style={{ padding: '1rem', width: '100%' }}>
          <TextField
            variant='outlined'
            label='Password'
            placeholder='Enter Password'
            type={view ? 'text' : 'password'}
            name='password'
            value={values.password}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors.password && touched.password}
            helperText={errors.password && touched.password && errors.password}
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>
                  <LockIcon />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position='end'>
                  {!view ? (
                    <VisibilityIcon
                      style={{ cursor: 'pointer' }}
                      onClick={() => setView(!view)}
                    />
                  ) : (
                    <VisibilityOffIcon
                      style={{ cursor: 'pointer' }}
                      onClick={() => setView(!view)}
                    />
                  )}
                </InputAdornment>
              ),
            }}
          />
        </FormControl>
      </CardBody>
      <CardFooter>
        <Button
          type='submit'
          onClick={() => {
            if (!values.password) {
              dispatch(
                setAlert('Please fill in password properly!', 'warning')
              );
            }
          }}
          color='danger'
          round
          fullWidth
        >
          Reset Password
        </Button>

        {check ? <CheckFormikValues {...props} /> : ''}
      </CardFooter>
    </form>
  );
};

export { ResetPasswordForm };
